import { useSyncExternalStore } from 'react';

/**
 * Sayfanın veri okuması yetkisiz döndü mü (ADR 0067 §6): API istemcisi `FORBIDDEN` alan okumayı
 * bildirir; ortak `EmptyState` o sayfadaki hata durumunu "yeniden dene" yerine "Bu sayfayı görme
 * yetkiniz yok" boş durumuyla gösterir. Kayıt bildirildiği yola bağlıdır: başka sayfaya geçince
 * kendiliğinden düşer. Yol tarayıcının konumundan okunur (web ofis); konum yoksa boş yol.
 */
let deniedPath: string | null = null;
const listeners = new Set<() => void>();

const here = (): string => globalThis.location?.pathname ?? '';

function emit() {
  for (const listener of listeners) listener();
}

/** Bu sayfanın okuması yetkisiz döndü (`403 FORBIDDEN`). */
export function reportAccessDenied(): void {
  const path = here();
  if (deniedPath === path) return;
  deniedPath = path;
  emit();
}

/** Kaydı siler (oturum değişince ve testlerde). */
export function clearAccessDenied(): void {
  if (deniedPath === null) return;
  deniedPath = null;
  emit();
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** Bulunulan sayfanın okuması yetkisiz döndüyse `true` (hook dışı okuma). */
export function isAccessDenied(): boolean {
  return deniedPath !== null && deniedPath === here();
}

const snapshot = isAccessDenied;

/** Bulunulan sayfanın okuması yetkisiz döndüyse `true`. */
export function useAccessDenied(): boolean {
  return useSyncExternalStore(subscribe, snapshot, snapshot);
}
